module.exports = __webpack_public_path__ + "media/images/mobile/solutions/explr-bg3-4748b7ac47797b45010a1ec5e175f1f8.png";